import React from "react";
import { Alert, Icon, Button } from "antd";
import get from "lodash/get";

import { ImednetReprocessing, ImednetCheckStatus } from "../../api/requests";

import classes from "./PatientProfileForm.css";
import { withNamespaces } from "react-i18next";

const statuses = {
  'completed': 'success',
  'declined': 'error',
  'error': 'error',
  'pending': 'warning',
  'idle': 'info',
};

class PatientImednetProcessing extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isSent: false,
      isLoading: false,
      requestResult: null,
      isSentStatus: false,
      isLoadingStatus: false,
      requestResultStatus: null,
    };
  }

  handleSubmit = async () => {
    this.setState({ isLoading: true });
    try {
      const data = await ImednetReprocessing(this.props.subjectID);

      this.setState({
        isSent: true,
        requestResult: {
          type: data.data.state,
          message: data.data.message,
        },
      });
    } catch (e) {
      this.setState({
        requestResult: {
          type: "error",
          message: this.props.i18n.t("Error"),
        },
      });
    }

    this.setState({ isLoading: false });
  };

  handleSubmitCheckStatus = async () => {
    this.setState({ isLoadingStatus: true });
    try {
      const data = await ImednetCheckStatus(this.props.subjectID);

      this.setState({
        isSentStatus: true,
        requestResultStatus: {
          type: data.data.state,
          message: data.data.message,
        },
      });
    } catch (e) {
      this.setState({
        requestResultStatus: {
          type: "error",
          message: this.props.i18n.t("Error"),
        },
      });
    }

    this.setState({ isLoadingStatus: false });
  };

  render() {
    const {} = this.props;

    const {
      isLoading,
      isSent,
      requestResult,
      isLoadingStatus,
      isSentStatus,
      requestResultStatus,
    } = this.state;

    return (
      <div className={classes.patientProfileForm}>
        <div>
          <Button
            disabled={isSent}
            type="primary"
            size="large"
            htmlType="button"
            onClick={this.handleSubmit}
            className={classes.submitButton}
          >
            {this.props.i18n.t('NamespacePatientAPIControls:Imednet Push Subject')}
            {isLoading && <Icon type="loading" />}
          </Button>
          <br/><br/>
          {requestResult && requestResult.type &&
          <Alert message={requestResult.message} type={statuses[requestResult.type]} style={{ width: '300px'}}/>
          }
        </div>

        <br/>


        <div>
          <Button
            disabled={isSentStatus}
            type="primary"
            size="large"
            htmlType="button"
            onClick={this.handleSubmitCheckStatus}
            className={classes.submitButton}
          >
            {this.props.i18n.t('NamespacePatientAPIControls:Imednet Check Status')}
            {isLoadingStatus && <Icon type="loading" />}
          </Button>
          <br/><br/>
          {requestResultStatus && requestResultStatus.type &&
          <Alert message={requestResultStatus.message} type={statuses[requestResultStatus.type]} style={{ width: '300px'}}/>
          }
        </div>
      </div>
    );
  }
}

export default withNamespaces()(PatientImednetProcessing);



// WEBPACK FOOTER //
// ./src/components/PatientProfileForm/PatientImednetProcessing.js